<template>
  <div class="rotator-slide__wrapper">
    <div class="starting-date" v-if="slide.isFirstOfDay">
      {{
        (slide.display_start_at || slide.start_at)
          | moment("timezone", "America/Chicago", "dddd MMM Do")
      }}
    </div>
    <div
      @click="setActive"
      @keyup.enter="setActive"
      :class="classList"
      role="button"
      tabindex="0"
    >
      <div class="rotator-slide__item">
        <div class="rotator-slide__icon-box">
          <img
            class="rotator_slide__icon"
            src="@/assets/timeline-play.png"
            alt="play-img"
          />
        </div>
        <div class="rotator-slide__content">
          <div class="rotator-slide__time">
            {{
              (slide.display_start_at || slide.start_at)
                | moment(
                  "timezone",
                  "America/Chicago",
                  slide.end_at ? "h:mm - " : "h:mm a"
                )
            }}
            {{ slide.end_at | moment("timezone", "America/Chicago", "h:mm a") }}
            &nbsp;CT
          </div>
          <div
            class="rotator-slide__topic"
            v-html="slide.title_html || slide.title"
          ></div>
        </div>
      </div>

      <div class="rotator-slide__now-playing">now playing</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MomentRotatorSlide",
  props: {
    value: Number,
    displayValue: Number,
    slide: Object
  },
  methods: {
    setActive() {
      this.$gtag.event("TimelineRotator", {
        event_category: "click",
        event_label: "eventId",
        value: this.slide.id
      });

      this.$emit("input", this.slide.id);

      if (this.slide.url) {
        window.open(this.slide.url, "_blank");
      }
    }
  },
  computed: {
    classList() {
      const { id, status } = this.slide;
      return {
        active: id == this.displayValue,
        earlier: status == "earlier",
        just_posted: status == "just_posted",
        soon: status == "coming_soon",
        "rotator-slide": true
      };
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.rotator-slide__wrapper {
  overflow: visible;
  position: relative;

  .starting-date {
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    position: absolute;
    top: -45px;
  }

  .v-responsive {
    overflow: visible;
  }
}
.rotator-slide {
  position: relative;

  &__item {
    border: 4px solid transparent;
    border-radius: 10px;
    background-color: $primary;
    display: flex;
    overflow: hidden;
    min-height: 106px;
  }

  &__icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 7vw;
    height: 100%;
    margin: auto 0;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.7vw;
    background-color: white;
    color: $primary;
  }

  &__time {
    font-weight: 800;
    font-size: 16px;
    line-height: 1.2;
  }

  &__topic {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.1;
  }

  &__now-playing {
    font-weight: 800;
    font-size: 0.7vw;
    line-height: 1.6;
    text-transform: uppercase;
    background: $stjude-aqua;
    align-items: center;
    color: white;
    padding: 2px 4px;
    border-radius: 3px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
    display: none;
    position: absolute;
    top: 0;
    left: 3.5vw;
    transform: translate(-50%, -50%);
  }

  &.active {
    .rotator-slide__item {
      background-color: $stjude-red;
      color: $stjude-red;
    }

    .rotator-slide__now-playing {
      display: inline-flex;
    }
  }
}

@media screen and (max-width: 960px) {
  .rotator-slide {
    &__icon-box {
      width: 18vw;
      height: 20vw;
    }

    &__time {
      font-size: 16px;
    }

    &__topic {
      font-size: 14px;
    }

    &__now-playing {
      font-size: 9px;
      left: 13px;
      transform: translate(0, -50%);
    }
  }
}
</style>
